/**
 * @architecture-header 1
 * @layer module
 * @domain activities
 * @responsibility Apply the activity filters to the working dataset.
 * @state-owner navigation store owns the selected filter values
 * @allowed-imports React; workspace and dataset stores; shared view types
 * @forbidden API client; component markup
 * @public-api activities module and the workspace list column
 * @side-effects none
 * @tests workspace Playwright flows in frontend/apps/web/e2e/workspace.spec.ts
 */

import type { ActivityRecord } from '../../../shared/lib/model';
import { useDatasetStore } from '../../../shared/model/dataset-store';
import { useWorkspaceUiStore } from '../../../shared/model/workspace-store';

export function useActivityFilter(): readonly ActivityRecord[] {
  const activities = useDatasetStore((state) => state.activities);
  const filters = useWorkspaceUiStore((state) => state.filters.act);
  const status = filters?.st ?? [];
  const classIndexes = filters?.ci ?? [];
  const answerSource = filters?.ans ?? [];

  return activities.filter(
    (activity) =>
      (!status.length || status.includes(activity.status)) &&
      (!classIndexes.length ||
        classIndexes.some((value) =>
          value === '-1'
            ? activity.usedByClassIndexes.length === 0
            : activity.usedByClassIndexes.includes(Number(value)) ||
              activity.classIndex === Number(value),
        )) &&
      (!answerSource.length ||
        answerSource.includes(activity.answerSource === 'ai' ? 'ai' : 'file')),
  );
}

/** The single selected class, or null when the filter is broader. */
export function useSelectedActivityClass(): number | null {
  const filters = useWorkspaceUiStore((state) => state.filters.act);
  const values = filters?.ci ?? [];
  return values.length === 1 && values[0] !== '-1' ? Number(values[0]) : null;
}
